// src/components/storyboard/common/Constants.js
import React from "react";
import { VIDEO_PROVIDER_VOLCENGINE_SEEDANCE, DOMESTIC_SEEDANCE_MODELS, DOMESTIC_SEEDANCE_DURATIONS, DOMESTIC_SEEDANCE_RATIOS } from '../../../utils/domesticSeedanceCapabilities';
import {
  X,
  ZoomIn,
  ZoomOut,
  Anchor,
  Play,
  MessageCircle,
  Move,
  SwitchCamera,
  Eye,
  Monitor,
  Smartphone,
  Square,
  Film,
  Hexagon,
  Smile,
  Sparkles,
  Globe,
} from "lucide-react";
import {
  WANX_VIDEO_MODEL,
  WANX_VIDEO_MODELS,
  WANX_VIDEO_RESOLUTIONS,
} from "../../../utils/wanxVideoCapabilities";

export const CONTINUITY_OPTIONS = [
  { id: null, icon: <X size={10} />, label: "无" },
  { id: "ZOOM_IN", icon: <ZoomIn size={10} />, label: "推镜头" },
  { id: "ZOOM_OUT", icon: <ZoomOut size={10} />, label: "拉镜头" },
  { id: "SAME_POSE", icon: <Anchor size={10} />, label: "定格" },
  { id: "ACTION_FLOW", icon: <Play size={10} />, label: "动作接续" },
  { id: "REACTION", icon: <MessageCircle size={10} />, label: "反应" },
  { id: "ANGLE_SHIFT", icon: <Move size={10} />, label: "微移" },
  { id: "REVERSE_SHOT", icon: <SwitchCamera size={10} />, label: "正反打" },
  { id: "POV", icon: <Eye size={10} />, label: "POV" },
];

export const ASPECT_RATIOS = [
  { id: "16:9", label: "16:9 宽屏", icon: Monitor },
  { id: "9:16", label: "9:16 竖屏", icon: Smartphone },
  { id: "4:3", label: "4:3 电视", icon: Square },
  { id: "2.35:1", label: "2.35:1 电影", icon: Film },
];

export const VIDEO_MODELS = [
  {
    id: VIDEO_PROVIDER_VOLCENGINE_SEEDANCE, name: 'Seedance 2.0（国内官方）', tag: '官方',
    icon: Sparkles, accentColor: '#8b5cf6', generationMode: 'multi',
    durations: [...DOMESTIC_SEEDANCE_DURATIONS], defaultDuration: 5,
    defaultSubModel: DOMESTIC_SEEDANCE_MODELS[0].id, ratios: [...DOMESTIC_SEEDANCE_RATIOS],
    desc: '官方 2.0 / Fast / Mini，使用国内官方素材库',
    subModels: DOMESTIC_SEEDANCE_MODELS.map((model) => ({ ...model, durationRange: [4, 15], defaultDuration: 5, defaultResolution: '720p', supportsAudio: true })),
  },
  // {
  //   id: "minimax",
  //   name: "海螺 (Hailuo)",
  //   tag: "写实",
  //   tagColor: "bg-blue-500/10 text-blue-300 border-blue-500/20",
  //   accentColor: "#3b82f6",
  //   icon: Aperture,
  //   durations: ["6s"],
  //   defaultDuration: "6s",
  //   desc: "光影质感极佳，适合电影感真人实拍",
  // },
  // {
  //   id: "jimeng",
  //   name: "即梦",
  //   tag: "音画同步",
  //   tagColor: "bg-emerald-500/10 text-emerald-300 border-emerald-500/20",
  //   accentColor: "#10b981",
  //   icon: Box,
  //   durations: ["4s", "8s", "12s"],
  //   defaultDuration: "4s",
  //   desc: "推荐高质量分镜视频",
  // },
  // {
  //   id: "sora2",
  //   name: "Sora 2",
  //   tag: "动漫",
  //   tagColor: "bg-purple-500/10 text-purple-300 border-purple-500/20",
  //   icon: Palette,
  //   durations: ["10s", "15s"],
  //   defaultDuration: "10s",
  //   desc: "二次元/3D动漫风格表现优异",
  // },
  //   {
  //     id: "fastSora2", // ✅ 修改此处，必须与后端 @Service("fastSora2") 一致
  //     name: "Fast Sora 2", // 也可以顺便改下显示名称
  //     tag: "极速版",
  //     tagColor: "bg-blue-500/10 text-blue-300 border-blue-500/20",
  //     icon: Smile,
  //     durations: ["4s", "8s", "12s"],
  //     defaultDuration: "4s",
  //     desc: "Sora 2.0 模型接口",
  //   },
  // {
  //   id: "wangsuSora",
  //   name: "Sora 2",
  //   tag: "推荐",
  //   tagColor: "bg-emerald-500/10 text-emerald-300 border-emerald-500/20",
  //   accentColor: "#10b981",
  //   icon: Zap,
  //   durations: ["4s", "8s", "12s"],
  //   defaultDuration: "4s",
  //   desc: "Sora 2，支持标准版和 Pro 版",
  //   subModels: [
  //     {
  //       id: "sora-2",
  //       name: "Sora 2",
  //       durationRange: [4, 12],
  //       defaultDuration: 4,
  //       durations: [4, 8, 12],
  //       resolutions: ["720x1280", "1280x720"],
  //       defaultResolution: "1280x720",
  //       supportsBgm: false,
  //       supportsAudio: false,
  //       supportsAudioType: false,
  //       supportsVoiceId: false,
  //       supportsMovementAmplitude: false,
  //     },
  //     {
  //       id: "sora-2-pro",
  //       name: "Sora 2 Pro",
  //       durationRange: [20, 25],
  //       defaultDuration: 20,
  //       durations: [20, 25],
  //       resolutions: ["720x1280", "1280x720", "1792x1024", "1024x1792"],
  //       defaultResolution: "1280x720",
  //       supportsBgm: false,
  //       supportsAudio: false,
  //       supportsAudioType: false,
  //       supportsVoiceId: false,
  //       supportsMovementAmplitude: false,
  //     },
  //   ],
  // },
  // {
  //   id: "sora2-pro",
  //   name: "Sora 2 Pro",
  //   tag: "动漫+",
  //   tagColor: "bg-pink-500/10 text-pink-300 border-pink-500/20",
  //   icon: Crown,
  //   durations: ["15s", "25s"],
  //   defaultDuration: "25s",
  //   desc: "超长时长，画面细节更丰富",
  // },
  {
    id: "wanx",
    name: "万相 3.0",
    tag: "全能参考",
    tagColor: "bg-[var(--color-blue-light)] text-[var(--color-blue-primary)] border-[color-mix(in_srgb,var(--color-blue-primary)_20%,transparent)]",
    accentColor: "#6366f1", // 功能色：模型品牌色（引用处按 hex+透明度后缀拼接，如 `${accentColor}15`），不接入主题变量
    icon: Hexagon,
    durations: ["-1", ...Array.from({ length: 29 }, (_, index) => `${index + 2}s`)],
    defaultDuration: "5s",
    desc: "文生、首帧、首尾帧与多模态参考统一生成",
    subModels: [
      ...WANX_VIDEO_MODELS.map(({ value, label, description }) => ({
        id: value,
        name: `Wan 3.0 ${label}`,
        desc: description,
        durationRange: [2, 30],
        defaultDuration: 5,
        resolutions: [...WANX_VIDEO_RESOLUTIONS],
        defaultResolution: "1080P",
        supportsAudio: true,
      })),
    ],
    defaultSubModel: WANX_VIDEO_MODEL,
    resolutions: [...WANX_VIDEO_RESOLUTIONS],
    defaultResolution: "1080P",
    ratios: ["adaptive", "16:9", "4:3", "1:1", "3:4", "9:16"],
  },
  {
    id: "vidu",
    name: "Vidu",
    tag: "性价比",
    tagColor: "bg-[var(--color-blue-light)] text-[var(--color-blue-primary)] border-[color-mix(in_srgb,var(--color-blue-primary)_20%,transparent)]",
    accentColor: "#3b82f6", // 功能色：模型品牌色（hex+透明度后缀拼接使用），不接入主题变量
    icon: Smile,
    durations: ["4s", "8s", "16s"],
    defaultDuration: "4s",
    desc: "国产动漫模型，性价比较高",
    subModels: [
      {
        id: "viduq3-turbo",
        name: "Q3 Turbo",
        durationRange: [1, 16],
        defaultDuration: 5,
        supportsBgm: false,
        supportsAudio: true,
        supportsAudioType: false,
        supportsVoiceId: false,
        supportsMovementAmplitude: false,
        resolutions: ["540p", "720p", "1080p"],
        defaultResolution: "720p"
      },
      {
        id: "viduq3-pro",
        name: "Q3 Pro",
        durationRange: [1, 16],
        defaultDuration: 5,
        supportsBgm: false,
        supportsAudio: true,
        supportsAudioType: false,
        supportsVoiceId: false,
        supportsMovementAmplitude: false,
        resolutions: ["540p", "720p", "1080p"],
        defaultResolution: "720p"
      },
      {
        id: "viduq2-pro-fast",
        name: "Q2 Pro Fast",
        durationRange: [1, 10],
        defaultDuration: 5,
        supportsBgm: true,
        supportsAudio: true,
        supportsAudioType: true,
        supportsVoiceId: true,
        supportsMovementAmplitude: false,
        resolutions: ["720p", "1080p"],
        defaultResolution: "720p"
      },
      {
        id: "viduq2-pro",
        name: "Q2 Pro",
        durationRange: [1, 10],
        defaultDuration: 5,
        supportsBgm: true,
        supportsAudio: true,
        supportsAudioType: true,
        supportsVoiceId: true,
        supportsMovementAmplitude: false,
        resolutions: ["720p", "1080p"],
        defaultResolution: "720p"
      },
      {
        id: "viduq2-turbo",
        name: "Q2 Turbo",
        durationRange: [1, 10],
        defaultDuration: 5,
        supportsBgm: true,
        supportsAudio: true,
        supportsAudioType: true,
        supportsVoiceId: true,
        supportsMovementAmplitude: false,
        resolutions: ["720p", "1080p"],
        defaultResolution: "720p"
      },
      {
        id: "viduq1",
        name: "Q1",
        durationRange: [5, 5],
        defaultDuration: 5,
        supportsBgm: false,
        supportsAudio: true,
        supportsAudioType: true,
        supportsVoiceId: true,
        supportsMovementAmplitude: true,
        resolutions: ["1080p"],
        defaultResolution: "1080p"
      },
      {
        id: "viduq1-classic",
        name: "Q1 Classic",
        durationRange: [5, 5],
        defaultDuration: 5,
        supportsBgm: false,
        supportsAudio: true,
        supportsAudioType: true,
        supportsVoiceId: true,
        supportsMovementAmplitude: true,
        resolutions: ["1080p"],
        defaultResolution: "1080p"
      },
      {
        id: "vidu2.0",
        name: "Vidu 2.0",
        durationRange: [4, 8],
        defaultDuration: 4,
        supportsBgm: false,
        supportsAudio: true,
        supportsAudioType: true,
        supportsVoiceId: true,
        supportsMovementAmplitude: true,
        resolutions: ["360p", "720p", "1080p"],
        defaultResolution: "360p",
        resolutionByDuration: { 4: ["360p", "720p", "1080p"], 8: ["720p"] }
      },
    ],
  },
  {
    id: "guavideo",
    name: "GuaVideo",
    tag: "多模态",
    tagColor: "bg-[var(--color-purple-light)] text-[var(--color-purple-primary)] border-[color-mix(in_srgb,var(--color-purple-primary)_20%,transparent)]",
    accentColor: "#8b5cf6", // 功能色：模型品牌色（hex+透明度后缀拼接使用），不接入主题变量
    icon: Sparkles,
    generationMode: "multi",
    durations: ["4s", "5s", "6s", "7s", "8s", "9s", "10s", "11s", "12s", "13s", "14s", "15s"],
    subModels: [
      { id: "doubao-seedance-2-0-260128", name: "2.0 标准" },
      { id: "doubao-seedance-2-0-fast-260128", name: "2.0 Fast" },
    ],
    defaultDuration: 5,
    desc: "多模态参考生视频，支持参考图/视频/音频",
  },
  {
    id: "engguavideo",
    name: "EngGuaVideo",
    tag: "出海",
    tagColor: "bg-[var(--color-green-light)] text-[var(--color-success)] border-[color-mix(in_srgb,var(--color-success)_20%,transparent)]",
    accentColor: "#22c55e", // 功能色：模型品牌色（hex+透明度后缀拼接使用），不接入主题变量
    icon: Sparkles,
    generationMode: "multi",
    durations: ["4s", "5s", "6s", "7s", "8s", "9s", "10s", "11s", "12s", "13s", "14s", "15s"],
    subModels: [
      { id: "dreamina-seedance-2-0", name: "Dreamina 2.0" },
      { id: "dreamina-seedance-2-0-fast", name: "Dreamina 2.0 Fast" },
    ],
    defaultDuration: 5,
    desc: "EngGuaVideo 海外视频生成",
  },
  {
    id: "omini_seedance",
    name: "GuaOmini",
    tag: "出海线路",
    tagColor: "bg-[var(--color-blue-light)] text-[var(--color-info)] border-[color-mix(in_srgb,var(--color-info)_20%,transparent)]",
    accentColor: "#38bdf8",
    icon: Globe,
    generationMode: "multi",
    durations: ["4s", "5s", "6s", "7s", "8s", "9s", "10s", "11s", "12s", "13s", "14s", "15s"],
    subModels: [
      { id: "dreamina-seedance-2-0", name: "2.0 标准" },
      { id: "dreamina-seedance-2-0-fast", name: "2.0 Fast" },
    ],
    defaultDuration: 5,
    desc: "GuaOmini 海外视频生成，使用独立项目素材库",
  },
  {
    id: "happyhorse",
    name: "HappyHorse",
    tag: "真实",
    tagColor: "bg-[var(--color-green-light)] text-[var(--color-success)] border-[color-mix(in_srgb,var(--color-success)_20%,transparent)]",
    accentColor: "#10b981", // 功能色：模型品牌色（hex+透明度后缀拼接使用），不接入主题变量
    icon: Film,
    durations: ["3s", "4s", "5s", "6s", "7s", "8s", "9s", "10s", "11s", "12s", "13s", "14s", "15s"],
    defaultDuration: "5s",
    resolutions: ["1080P", "720P"],
    subModels: [
      { id: "happyhorse-t2v", name: "文生视频", durationRange: [3, 15] },
      { id: "happyhorse-i2v", name: "图生视频", durationRange: [3, 15] },
      { id: "happyhorse-r2v", name: "参考生视频", durationRange: [3, 15] },
      { id: "happyhorse-edit", name: "视频编辑" },
    ],
    desc: "物理真实、运动流畅，支持参考生视频和视频编辑",
  },
];

// ✅ 共享风格选项
export const STYLE_OPTIONS = [
    { value: "custom", label: "自定义（无风格）" },
    { value: "modern_cdrama", label: "中国现代真人短剧" },
    { value: "ancient_cdrama", label: "中国古代真人短剧" },
    { value: "ancient_fantasy_cdrama", label: "中国古代玄幻真人短剧" },
    { value: "realistic", label: "真人电影" },
    { value: "cinematic_cg", label: "电影CG动画" },
    { value: "semi_realistic_3d_otome", label: "半写实3D乙女CG" },
    { value: "chinese_3d_donghua", label: "中国3D国漫" },
    { value: "pixar", label: "皮克斯3D动画" },
    { value: "donghua", label: "中国国漫2D" },
    { value: "anime", label: "日漫2D" },
    { value: "cel_2d", label: "2D赛璐璐动画" },
];
